import React, { useState } from 'react';
import { Info, X } from 'lucide-react';

const KEY = 'practcom-spam-tip-dismissed';

const TipText = () => (
  <>
    <span className="font-semibold">Texts not showing up?</span> Phones sometimes file texts from a new business number as spam.
    Ask the patient to check <span className="font-medium">iPhone: Messages → Filters → Unknown Senders / Junk</span> or{' '}
    <span className="font-medium">Android: Messages → Spam &amp; blocked</span>. Once they tap "Report Not Junk" or save our number as a contact, future texts arrive normally.
  </>
);

// Full banner (Messages page); dismissible per browser.
export const SpamFolderTip = () => {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === '1');
  if (hidden) return null;
  return (
    <div className="flex items-start gap-3 px-5 py-2.5 bg-amber-50 border-b border-amber-200 text-sm text-amber-900" data-testid="sms-spam-tip">
      <Info className="h-4 w-4 mt-0.5 shrink-0 text-amber-600" />
      <p className="flex-1"><TipText /></p>
      <button onClick={() => { localStorage.setItem(KEY, '1'); setHidden(true); }} className="text-amber-700 hover:text-amber-900" aria-label="Dismiss tip" data-testid="sms-spam-tip-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

// Compact note (Message Patient dialog).
export const SpamFolderNote = () => (
  <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2" data-testid="sms-spam-note">
    <TipText />
  </p>
);
